import { render, staticRenderFns } from "./LookBookEdit.vue?vue&type=template&id=3bcaa4bd&"
import script from "./LookBookEdit.vue?vue&type=script&lang=js&"
export * from "./LookBookEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports